import { render, staticRenderFns } from "./userGradeDetail.vue?vue&type=template&id=b69a406c&scoped=true&"
import script from "./userGradeDetail.vue?vue&type=script&lang=js&"
export * from "./userGradeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69a406c",
  null
  
)

export default component.exports